import React, { useEffect, useMemo, useState } from "react";
import { Box, IconButton, Modal, TextField, Button } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";

import {
  fetchClientNameData,
  fetchOrgClientWiseData,
  fetchmoduleorgwise,
  fetchroleorgwise,
  insertmapmodulerole,
} from "../../../../services/apiService";

function AddMapModule({ isModalOpen, closeModal }) {
  const clientid = localStorage.getItem("clientId");
  const mstorgnhierarchytypeid = localStorage.getItem("organizationid");

  if (!toast.isActive("userNotFound")) {
    toast("User does not exist", {
      toastId: "userNotFound",
      containerId: "friendRequest",
      position: "bottom-right",
      autoClose: false,
      closeOnClick: true,
      draggable: false,
      type: "error",
    });
  }

  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedParentVal, setSelectedParentVal] = useState("");
  const [selectedOrgRollParentVal, setSelectedOrgRollParentVal] = useState("");
  const [selectedOrgModuleParentVal, setSelectedOrgModuleParentVal] =
    useState("");
  const [organizationData, setOrganizationData] = useState([]);
  const [modulebasedData, setModuleBasedData] = useState([]);
  const [rollbasedData, setRollBasedData] = useState([]);

  useEffect(() => {
    if (isModalOpen) {
      fetchClientNames();
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (selectedClient) {
      handleOrgClientWise();
    }
  }, [selectedClient]);

  useEffect(() => {
    if (selectedParentVal) {
      fetchModuleByOrgWise();
    }
  }, [selectedParentVal]);

  useEffect(() => {
    if (selectedOrgModuleParentVal) {
      fetchRollByOrgWise();
    }
  }, [selectedOrgModuleParentVal]);

  const fetchClientNames = async () => {
    const loadingToastId = toast.loading("Loading client data...", {
      toastId: "loadingClients",
      containerId: "clientContainer",
    });

    try {
      const response = await fetchClientNameData({});

      toast.dismiss(loadingToastId);

      if (response?.success && Array.isArray(response.details)) {
        setClients(response.details || []);

        if (!toast.isActive("clientLoaded")) {
          toast.success("Client data loaded successfully!", {
            toastId: "clientLoaded",
            autoClose: 2000,
            containerId: "clientContainer",
          });
        }
      } else {
        toast.error("Invalid response structure", {
          autoClose: 2000,
          containerId: "clientContainer",
        });
      }
    } catch (err) {
      console.error("Error fetching client name data:", err);
      toast.dismiss(loadingToastId);
      toast.error("Error fetching client name data.", {
        autoClose: 2000,
        containerId: "clientContainer",
      });
    }
  };

  const handleOrgClientWise = async () => {
    const loadingToastId = toast.loading("Fetching organization data...", {
      toastId: "orgLoading",
      containerId: "orgContainer",
    });

    try {
      if (!selectedClient) {
        toast.dismiss(loadingToastId);
        toast.error("Please select a client first.", {
          autoClose: 2000,
          containerId: "orgContainer",
        });
        return;
      }

      const clientId =
        typeof selectedClient === "string"
          ? parseInt(selectedClient, 10)
          : selectedClient;

      const response = await fetchOrgClientWiseData({ clientId });

      toast.dismiss(loadingToastId);

      if (response?.success && Array.isArray(response.details)) {
        setOrganizationData(response.details || []);
        if (!toast.isActive("orgLoaded")) {
          toast.success("Organization data loaded successfully!", {
            toastId: "orgLoaded",
            autoClose: 2000,
            containerId: "orgContainer",
          });
        }
      } else {
        toast.error("Error: Invalid response structure", {
          autoClose: 2000,
          containerId: "orgContainer",
        });
      }
    } catch (err) {
      console.error("Error fetching organization data:", err);
      toast.dismiss(loadingToastId);
      toast.error("Error fetching organization data.", {
        autoClose: 2000,
        containerId: "orgContainer",
      });
    }
  };

  const fetchModuleByOrgWise = async () => {
    const loadingToastId = toast.loading("Fetching Module data...", {
      toastId: "moduleLoading",
      containerId: "moduleContainer",
    });

    try {
      if (!modulebasedData) {
        toast.dismiss(loadingToastId);
        toast.error("Please select an Organization first.", {
          autoClose: 2000,
          containerId: "moduleContainer",
        });
        return;
      }

      const payload = {
        organizationid: Number(mstorgnhierarchytypeid),
        clientid: Number(clientid),
      };

      const response = await fetchmoduleorgwise(payload);

      toast.dismiss(loadingToastId);

      if (response?.success && Array.isArray(response.details)) {
        setModuleBasedData(response.details || []);
        if (!toast.isActive("moduleLoaded")) {
          toast.success("Module Based Organization data loaded successfully!", {
            toastId: "moduleLoaded",
            autoClose: 2000,
            containerId: "moduleContainer",
          });
        }
      } else {
        toast.error("Error: Invalid response structure", {
          autoClose: 2000,
          containerId: "moduleContainer",
        });
      }
    } catch (err) {
      console.error("Error fetching module data:", err);
      toast.dismiss(loadingToastId);
      toast.error("Error fetching data.", {
        autoClose: 2000,
        containerId: "moduleContainer",
      });
    }
  };

  const fetchRollByOrgWise = async () => {
    const loadingToastId = toast.loading("Fetching roll-based data...", {
      toastId: "roleLoading",
      containerId: "roleContainer",
    });

    try {
      if (!rollbasedData) {
        toast.dismiss(loadingToastId);
        toast.error("Please select an Organization first.", {
          autoClose: 2000,
          containerId: "roleContainer",
        });
        return;
      }

      const payload = {
        organizationid: Number(selectedParentVal),
        clientid: Number(selectedClient),
      };

      const response = await fetchroleorgwise(payload);

      toast.dismiss(loadingToastId);

      if (response?.success && Array.isArray(response.details)) {
        setRollBasedData(response.details || []);
        if (!toast.isActive("roleLoaded")) {
          toast.success("Roll Based Organization data loaded successfully!", {
            toastId: "roleLoaded",
            autoClose: 2000,
            containerId: "roleContainer",
          });
        }
      } else {
        toast.error("Error: Invalid response structure", {
          autoClose: 2000,
          containerId: "roleContainer",
        });
      }
    } catch (err) {
      console.error("Error fetching roll-based data:", err);
      toast.dismiss(loadingToastId);
      toast.error("Error fetching data.", {
        autoClose: 2000,
        containerId: "roleContainer",
      });
    }
  };

  const handleSubmit = async (e) => {
    if (
      !selectedClient ||
      !selectedParentVal ||
      !selectedOrgModuleParentVal ||
      !selectedOrgRollParentVal
    ) {
      toast.error("Please select all required fields.");
      return;
    }


    const payload = {
      clientid: parseInt(selectedClient, 10),
      organizationid: parseInt(selectedParentVal, 10),
      moduleid: parseInt(selectedOrgModuleParentVal, 10),
      roleid: parseInt(selectedOrgRollParentVal, 10),
    };

    const loadingToastId = toast.loading("Submitting Map Module with Role mapping...", {
      toastId: "submitLoading",
      containerId: "submitContainer",
    });

    try {
      const response = await insertmapmodulerole(payload);

      toast.dismiss(loadingToastId);

      if (response?.success) {
        toast.success("Module mapping successful!");
      } else {
        toast.error("Error mapping Module.");
      }
    } catch (err) {
      console.error("Error inserting Module:", err);
      toast.dismiss(loadingToastId);
      toast.error("Error submitting the form.");
    }
  };

  return (
    <div>
      {/* // add client modal pop up  */}
      <div
        className={`fixed inset-0 bg-gray-500 bg-opacity-50 z-50 transition-opacity ${
          isModalOpen ? "block" : "hidden"
        }`}
      >
        <div className="flex justify-center items-center min-h-screen">
          <div className="bg-white p-6 rounded-lg shadow-lg w-6/12">
            <h2 className="text-2xl text-center font-semibold mb-4">
            Map Module with Role

            </h2>

            <form onSubmit={handleSubmit}>
              {/* Client Name */}

              <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6 mb-3">
                <div className="mb-3">
                  <label
                    htmlFor="clientName"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Select Client
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                        value={selectedClient}
                        onChange={(e) => setSelectedClient(e.target.value)}
                      >
                        <option value="">Select Client</option>
                        {clients.map((client, index) => (
                          <option key={index} value={client.id}>
                            {client.name}
                          </option>
                        ))}
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Client Code */}
                <div className="mb-3">
                  <label
                    htmlFor="clientCode"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Select Organization
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        value={selectedParentVal}
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                        onChange={(e) => setSelectedParentVal(e.target.value)}
                      >
                        <option value="">Select Parent Organization</option>
                        {organizationData.map((org, index) => (
                          <option key={index} value={org.id}>
                            {org.organizationname}
                          </option>
                        ))}
                      </select>

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="clientCode"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Select Module
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        value={selectedOrgModuleParentVal}
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                        onChange={(e) =>
                          setSelectedOrgModuleParentVal(e.target.value)
                        }
                      >
                        <option value="">Select Parent Organization</option>
                        {modulebasedData.map((modulebaseorg, index) => (
                          <option key={index} value={modulebaseorg.id}>
                            {modulebaseorg.modulename}
                          </option>
                        ))}
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="clientCode"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Select Role
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        value={selectedOrgRollParentVal}
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                        onChange={(e) =>
                          setSelectedOrgRollParentVal(e.target.value)
                        }
                      >
                        <option value="">Select Parent Organization</option>
                        {rollbasedData.map((rollbaseorg, index) => (
                          <option key={index} value={rollbaseorg.id}>
                            {rollbaseorg.rolename}
                          </option>
                        ))}
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
                {/* Submit and Close Buttons */}
                <div className="col-span-2 flex justify-between space-x-4">
                  <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Submit
                  </button>
                  <button
                    onClick={closeModal}
                    className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-400 focus:outline-none"
                  >
                    Close Modal
                  </button>
                </div>
              </div>
            </form>

            {/* Close button */}
          </div>
        </div>
      </div>
      <ToastContainer containerId="clientContainer" />
      <ToastContainer containerId="orgContainer" />
      <ToastContainer containerId="moduleContainer" />
    </div>
  );
}

export default AddMapModule;
